import { Box } from '@mui/material';
import { CleaningMissionPriority } from '@silbo/core';
import { colors } from '@silbo/ui';

type CleaningMissionPrioritySquareProps = {
  priority?: CleaningMissionPriority;
};

const SQUARE_COLORS: Record<CleaningMissionPriority, { background: string; text: string }> = {
  P0: { background: colors.red[80], text: '#FFFFFF' },
  P1: { background: colors.orange[90], text: '#FFFFFF' },
  P2: { background: colors.yellow[60], text: colors.grey[100] },
};

const NO_PRIORITY = { background: colors.grey[5], text: colors.grey[40] };

const CleaningMissionPrioritySquare = ({ priority }: CleaningMissionPrioritySquareProps) => {
  const { background, text } = priority ? SQUARE_COLORS[priority] : NO_PRIORITY;
  return (
    <Box
      sx={{
        flex: 'none',
        width: 44,
        height: 44,
        borderRadius: '10px',
        bgcolor: background,
        color: text,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        fontWeight: 800,
      }}
    >
      {priority ?? '–'}
    </Box>
  );
};

export default CleaningMissionPrioritySquare;
